export { type FeaturedProductsProps, default as FeaturedProducts } from './FeaturedProducts';
